import React from 'react'
import _ from 'lodash'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import { Button, Section } from '..'
import * as styles from './styles'

const propTypes = {
  data: PropTypes.object.isRequired,
  icons: PropTypes.array.isRequired
}

export default function ColorBlockList({ data, icons }) {
  return (
    <styles.Container>
      <styles.BlockSubContainer>
        <Row>
          <Col xs={12}>
            <styles.BlockHeader>
              {data.greenBlockHeader}
            </styles.BlockHeader>
          </Col>
        </Row>
        <Section>
          <Row>
            {_.map(data.greenBlockItems, (item, i) => {
              return (
                <Col sm={4} xs={12} key={i}>
                  <styles.StyledLinkCard href={item.url} target="_blank" rel="noreferrer noopener">
                    <styles.CardContainer>
                      <div>
                        {icons[i]}
                        <styles.CardHeader>
                          {item.header}
                        </styles.CardHeader>
                        <styles.CardText>
                          {item.text}
                        </styles.CardText>
                      </div>
                      <div className="learn-more">
                        Learn more
                        <styles.Chevron />
                      </div>
                    </styles.CardContainer>
                  </styles.StyledLinkCard>
                </Col>
              )
            })}
          </Row>
        </Section>

        <styles.CallToActionContainer>
          <styles.CTAHeader>
            {data.greenBlockCTAHeader}
          </styles.CTAHeader>
          {data.greenBlockCTAButtonUrl && (
            <Link to={data.greenBlockCTAButtonUrl}>
              <Button size="small">{data.greenBlockCTAButtonText}</Button>
            </Link>
          )}
        </styles.CallToActionContainer>
      </styles.BlockSubContainer>
    </styles.Container>
  )
}

ColorBlockList.propTypes = propTypes
